import {useContext} from "react";
import {useMatch} from "@tanstack/react-location";
import {isEmpty} from "lodash";
import {TableContainer, Table} from "@onemind-services-llc/ui-components";
import InvoiceCard from "./invoiceCard";
import {UserContext} from "../../../../contexts/userContext";
import {
  useListSubscriptionInvoicesBillingSubscriptionsIdInvoicesGet,
  useUpdateUserMetadataAuthUserMetadataPatch,
} from "../../../../orval-cml/default/default";
import {defaultColumns, columnsList} from "./invoicesTableColumns";

const Invoices = () => {
  const userProfile = useContext(UserContext);
  const {user_metadata = {}} = userProfile || {};
  const {table = {}} = user_metadata;
  const {invoiceColumns = []} = table;

  const {
    params: {subscriptionId},
  } = useMatch();

  const {data: {data: {results: invoicesList = []} = {}} = {}, isLoading} = useListSubscriptionInvoicesBillingSubscriptionsIdInvoicesGet(
    subscriptionId,
    {
      query: {
        queryKey: ["subscriptionInvoices", subscriptionId],
      },
    }
  );

  const {mutate: updateUserData} = useUpdateUserMetadataAuthUserMetadataPatch();

  const saveTableConfig = (columnList) => {
    updateUserData({
      data: {
        user_metadata: {
          ...user_metadata,
          table: {...table, invoiceColumns: columnList},
        },
      },
    });
  };

  return (
    <TableContainer>
      <Table
        card={InvoiceCard}
        columns={defaultColumns}
        data={invoicesList}
        isLoading={isLoading}
        tableConfigProps={{
          columnsList: isEmpty(invoiceColumns) ? columnsList : invoiceColumns,
          saveTableConfig,
        }}
      />
    </TableContainer>
  );
};

export default Invoices;
